// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import style from '../styles/RemoveSoldOut.style';
import BAGPAGE_LABELS from '../../../../BagPage/container/Bagpage.labels';
import CartItemTileLabels, {
  CHECKOUT_LABELS,
} from '../../../../CartItemTile/molecules/CartItemTile/views/CartItemTile.labels';

class RemoveSoldOut extends React.PureComponent {
  globalLabels = getLabelFromCopyOrFromTranslation('global', CartItemTileLabels) || {};

  moveItems = () => {
    const { moveItemsToBossUnavailableListAction, bossUnavailableProducts } = this.props;
    if (bossUnavailableProducts && bossUnavailableProducts?.length > 0) {
      moveItemsToBossUnavailableListAction(bossUnavailableProducts);
    }
  };

  getRemoveString = (labelMsg, removeCartItem, getUnavailableOOSItems, bossUnavailableProducts) => {
    const {
      pageView,
      bossUnavailableSwitch,
      isBossCart,
      isBossUnavailable,
      orderItems,
      getBossUnavailableItems,
    } = this.props;
    const { minibag } = this.globalLabels || {};
    const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CartItemTileLabels);
    const isMiniBag = pageView !== 'myBag';
    const newLabel = renderLabel(
      getDynamicLabelValues('dynamic.cart.lbl_boss_unavailable_group_header_error'),
      'lbl_boss_unavailable_group_header_error'
    );

    const isAllBossUnavailable = orderItems?.size === getBossUnavailableItems?.length;
    const showBossUnavailableError = !isAllBossUnavailable && isBossUnavailable;
    const remove =
      bossUnavailableSwitch && isBossCart && showBossUnavailableError
        ? newLabel?.split('#S2H')
        : labelMsg && labelMsg.split('#remove#');

    const newRemove =
      bossUnavailableSwitch && isBossCart && showBossUnavailableError ? (
        <BodyCopy
          fontFamily="secondary"
          fontSize="fs12"
          component="span"
          className="removeErrorMessage"
          onClick={() => this.moveItems(bossUnavailableProducts)}
        >
          {renderLabel(
            checkoutLabels?.bagPage?.lbl_boss_unavailable_global_error_subtext,
            'lbl_boss_unavailable_global_error_subtext'
          )}
        </BodyCopy>
      ) : (
        <BodyCopy
          fontFamily="secondary"
          fontSize="fs12"
          component="span"
          className="removeErrorMessage"
          onClick={() => removeCartItem({ getUnavailableOOSItems, isMiniBag })}
        >
          {renderLabel(minibag?.lbl_minibag_errorRemove, 'lbl_minibag_errorRemove')}
        </BodyCopy>
      );
    if (remove) {
      remove.splice(1, 0, newRemove);
    }

    return remove;
  };

  render() {
    const {
      className,
      pageView,
      removeCartItem,
      getUnavailableOOSItems,
      isSoldOut,
      isUnavailable,
      isNewBag,
      bossUnavailableProducts,
      isBossUnavailable,
    } = this.props;
    const { minibag } = this.globalLabels || {};
    const styleClass = pageView === 'myBag' ? 'bagTileItem' : 'removeItem';
    const labelMsg =
      (isSoldOut &&
        renderLabel(
          minibag?.lbl_minibag_errorRemoveSoldoutHeader,
          'lbl_minibag_errorRemoveSoldoutHeader'
        )) ||
      (isUnavailable &&
        renderLabel(
          minibag?.lbl_minibag_errorUpdateUnavailable,
          'lbl_minibag_errorUpdateUnavailable'
        )) ||
      (isBossUnavailable &&
        renderLabel(
          minibag?.lbl_minibag_errorUpdateUnavailable,
          'lbl_minibag_errorUpdateUnavailable'
        ));

    const { lbl_orderledger_free: freeLabel } = getLabelFromCopyOrFromTranslation(
      'checkout.bagPage',
      BAGPAGE_LABELS
    );

    const labelForRemove = this.getRemoveString(
      labelMsg,
      removeCartItem,
      getUnavailableOOSItems,
      bossUnavailableProducts,
      freeLabel
    );
    return (
      <>
        <div className={className}>
          <div className={'cont'}>
            {isNewBag && (
              <div
                className={`warning-icon  ${styleClass ? 'bag-style' : ''}`}
                aria-disabled="true"
              />
            )}

            <BodyCopy
              className={styleClass}
              component="span"
              fontFamily="secondary"
              fontSize="fs12"
            >
              {labelForRemove}
            </BodyCopy>
          </div>
        </div>
      </>
    );
  }
}

RemoveSoldOut.propTypes = {
  className: PropTypes.string,
  pageView: PropTypes.string,
  removeCartItem: PropTypes.func.isRequired,
  getUnavailableOOSItems: PropTypes.shape([]),
  isSoldOut: PropTypes.bool,
  isUnavailable: PropTypes.bool,
  isNewBag: PropTypes.bool,
};

RemoveSoldOut.defaultProps = {
  className: '',
  pageView: '',
  getUnavailableOOSItems: [],
  isSoldOut: false,
  isUnavailable: false,
  isNewBag: false,
};

export default withStyles(RemoveSoldOut, style);

export { RemoveSoldOut };
